import React from "react";
import {
  ImageCtaBase,
  Container,
  Content,
  PrimaryCopy,
  PrimaryImage,
  CTAStyled,
} from "./image-cta.styled";
import { ImageCtaSliceFragment } from "../../types/graphql";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";
import { GatsbyImage } from "gatsby-plugin-image";

export type IImageCtaProps = Slice<
  SharedSliceType.image_cta,
  ImageCtaSliceFragment["primary"]
> & { type: SharedSliceType.image_cta };

const ImageCta = ({
  slice,
  context,
}: SliceComponentProps<IImageCtaProps, IPageContext>) => {
  return (
    (slice && (
      <ImageCtaBase className="slice-section">
        <Container className="container">
          <Content>
            <PrimaryCopy>
              {slice.primary?.primary_heading && (
                <PrismicRichText
                  field={slice.primary?.primary_heading?.richText}
                  components={htmlSerializer}
                />
              )}
              {slice.primary?.primary_description?.richText && (
                <PrismicRichText
                  field={slice.primary?.primary_description.richText}
                  components={htmlSerializer}
                />
              )}
              {slice.primary.cta_text && slice.primary.cta_link?.url && (
                <CTAStyled
                  kind="primary"
                  pageSection="image-cta"
                  ctaText={slice.primary?.cta_text}
                  action={slice.primary?.cta_action}
                  linkURL={
                    slice.primary?.cta_link && slice.primary?.cta_link?.url
                  }
                  target={
                    slice.primary?.cta_link && slice.primary?.cta_link?.target
                  }
                />
              )}
            </PrimaryCopy>
            {slice.primary?.image?.gatsbyImageData && (
              <PrimaryImage>
                <GatsbyImage
                  image={slice.primary?.image.gatsbyImageData}
                  alt={slice.primary?.image.alt || "Xometry Image"}
                />
              </PrimaryImage>
            )}
          </Content>
        </Container>
      </ImageCtaBase>
    )) || <></> // exclude from purge
  );
};

export default ImageCta;
